import DropdownTemplateView from '../../../DropdownTemplateView'
import {connect} from '../../../redux/utils'
import ScrollableContainer from '../../../util/ScrollableContainer'
import LoadingContainer from '../../../util/LoadingContainer'
import {bindActionCreators} from 'redux'
import AssignmentsList from '../../../administration/userManagement/hierarchyAssignmentsPanelTab/components/AssignmentsList'
import {
    createNodesForCustomerList,
    createNodesForProjectList,
    createNodesForTaskList,
    entirelyAssignedCustomerTitle,
    entirelyAssignedProjectTitle,
    entirelyAssignedTaskTitle
} from '../../../administration/userManagement/hierarchyAssignmentsPanelTab/utils'
import {
    getAllAssignedCustomerCounter,
    getAllAssignedProjectCounter,
    getEntirelyAssignedProjectCounter,
    getEntirelyAssignedTasksCounter,
    selectCustomerEntities,
    selectProjectEntities,
    selectTaskEntities,
    isLoading,
    isNeedToLoadTaskData,
    isNeedToLoadProjectData,
    isNeedToLoadCustomerData,
} from '../selectors'
import {HierarchyLevels} from 'constants'
import {closeMenu, loadDataAction, openMenu} from '../actions'


class CPTAssignmentsListContainer extends DropdownTemplateView {
    constructor({
        additionalClass  = '',
        loadData = () => {},
        openMenu = () => {},
        closeMenu = () => {},
        createEntirelyAssignedTitle = () => {},
        createNodesForList = () => {},
        currentCptLevel: currentCptLevel = null,
    }) {
        super()

        this.params = {
            loadData,
            openMenu,
            closeMenu,
            createEntirelyAssignedTitle,
            createNodesForList,
            additionalClass,
            currentCptLevel,
        }

        this.isShown = true

        this.state = {
            loading: false,
            needToLoadData: null,

            nodeEntities: [],
            entirelyAssignedCurrentLevel: 0,
            entirelyAssignedPrevLevel: 0,
        }

        this.onStatePropertyBecameTrue('needToLoadData', () => {
            this.params.loadData()
        })

        this.onStatePropertyChanged('loading', (loading) => {
            this.content.setState({
                loading: loading
            })
        })

        this.onStatePropertyChanged('nodeEntities', (entities) => {
            this.content.setState({
                nodeEntities: entities,
            })
        })

        this.onStatePropertyChanged('entirelyAssignedCurrentLevel', (count) => {
            this.content.setState({
                entirelyAssignedCurrentLevel: count,
            })
        })

        this.onStatePropertyChanged('entirelyAssignedPrevLevel', (count) => {
            this.content.setState({
                entirelyAssignedPrevLevel: count,
            })
        })
    }

    templateHtml() {
        return '<div class="cptContainer <%-additionalClass%>">' +
               '    <div class="pointerPlaceholder">' +
               '        <div class="pointer"/>' +
               '    </div>' +
               '</div>'
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass
        }
    }


    afterRender() {
        this.assignmentsList = new AssignmentsList({
            revokeMap: {},
            entirelyAssignedTitle: this.params.createEntirelyAssignedTitle,
            createNodesForList: this.params.createNodesForList,
            hierarchyLevel: this.params.currentCptLevel,
        })

        this.loadingContainer = new LoadingContainer({
            contentComponent: this.assignmentsList,
            containerClass: '',
            loadingMoireConfig: {
                delay: 500
            }
        })

        this.content = new ScrollableContainer(null, this.loadingContainer).init(this.getEl())
    }

    onShow() {
        super.onShow()
        this.params.openMenu()
    }

    onHide() {
        super.onHide()
        this.params.closeMenu()
    }
}

export const TaskCPTAssignmentsListContainer = connect(
    state => ({
        loading: isLoading(state),
        needToLoadData: isNeedToLoadTaskData(state),

        nodeEntities: selectTaskEntities(state),
        entirelyAssignedCurrentLevel: getEntirelyAssignedTasksCounter(state),
        entirelyAssignedPrevLevel: getAllAssignedProjectCounter(state),
    }),
    dispatch => ({
        loadData: bindActionCreators(loadDataAction, dispatch),
        openMenu: () => bindActionCreators(openMenu, dispatch)(HierarchyLevels.TASK),
        closeMenu: bindActionCreators(closeMenu, dispatch),

        createEntirelyAssignedTitle: entirelyAssignedTaskTitle,
        createNodesForList: createNodesForTaskList,
    })
)(CPTAssignmentsListContainer)

export const ProjectCPTAssignmentsListContainer = connect(
    state => ({
        loading: isLoading(state),
        needToLoadData: isNeedToLoadProjectData(state),

        nodeEntities: selectProjectEntities(state),
        entirelyAssignedCurrentLevel: getEntirelyAssignedProjectCounter(state),
        entirelyAssignedPrevLevel: getAllAssignedCustomerCounter(state),
    }),
    dispatch => ({
        loadData: bindActionCreators(loadDataAction, dispatch),
        openMenu: () => bindActionCreators(openMenu, dispatch)(HierarchyLevels.PROJECT),
        closeMenu: bindActionCreators(closeMenu, dispatch),

        createEntirelyAssignedTitle: entirelyAssignedProjectTitle,
        createNodesForList: createNodesForProjectList,
    })
)(CPTAssignmentsListContainer)

export const CustomerCPTAssignmentsListContainer = connect(
    state => ({
        loading: isLoading(state),
        needToLoadData: isNeedToLoadCustomerData(state),

        nodeEntities: selectCustomerEntities(state),
        entirelyAssignedCurrentLevel: 0,
        entirelyAssignedPrevLevel: 0,
    }),
    dispatch => ({
        loadData: bindActionCreators(loadDataAction, dispatch),
        openMenu: () => bindActionCreators(openMenu, dispatch)(HierarchyLevels.CUSTOMER),
        closeMenu: bindActionCreators(closeMenu, dispatch),

        createEntirelyAssignedTitle: entirelyAssignedCustomerTitle,
        createNodesForList: createNodesForCustomerList,
    })
)(CPTAssignmentsListContainer)



// WEBPACK FOOTER //
// ./web/js/userProfile/cptAssignmentsList/components/CPTAssignmentsListContainer.js